export const getUniquePackageItems = (packageItems = [], activePackageIndex) =>
    packageItems?.reduce((acc, curr) => {
        if (!curr.personalizedAnnouncementItems) {
            const productCategoriesQuantity = curr?.displayQtyByPackageOsr[activePackageIndex]
            const productCategoryName = productCategoriesQuantity > 1
                ? `${productCategoriesQuantity} ${curr.displayName}`
                : `${curr.displayName}`

            if (!acc.includes(productCategoryName)) acc.push(productCategoryName)
        }

        return acc
    }, [])

export const getUniquePackageItemsWithSubProducts = (packageItems = [], activePackageIndex) =>
    packageItems?.reduce((acc, curr) => {
        if (!!curr?.personalizedAnnouncementItems) {
            const productCategoriesQuantity = curr?.displayQtyByPackageOsr?.[activePackageIndex]
            const isItemAlreadyPresent = !!acc.find(item => item.name === curr.displayName)

            const item = {
                name: curr.displayName,
                quantity: productCategoriesQuantity,
            }

            const subItems = curr.personalizedAnnouncementItems?.filter((subProduct) =>
                subProduct?.prodCatItem === activePackageIndex
            )

            item.subItems = subItems

            if (!isItemAlreadyPresent) {
                acc.push(item)
            }
        }

        return acc
    }, [])

export const getUniquePackagesByDisplayName = (items = []) => items?.reduce((acc, curr) => {
    const isItemAlreadyExisted = Boolean(acc.find((item) => item.displayName === curr.displayName))

    if (!isItemAlreadyExisted) acc.push(curr)

    return acc
}, [])